"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSearchInputTopAttribute = exports.getMobileCssHeightVariable = exports.getDesktopCssHeightVariable = void 0;
var _presentationUtils = require("@ori/presentation-utils");
const getMobileCssHeightVariable = ({
  isTopBannerVisible,
  showSearchOnScroll
}) => {
  if (isTopBannerVisible && showSearchOnScroll) {
    return _presentationUtils.CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  if (isTopBannerVisible) {
    return _presentationUtils.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  if (showSearchOnScroll) {
    return _presentationUtils.CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT;
  }
  return _presentationUtils.CSS_MOBILE_HEIGHT;
};
exports.getMobileCssHeightVariable = getMobileCssHeightVariable;
const getDesktopCssHeightVariable = ({
  isTopBannerVisible,
  isTopNavigationVisible
}) => {
  if (isTopBannerVisible && isTopNavigationVisible) {
    return _presentationUtils.CSS_DESKTOP_WITH_TOP_AREA_BANNER_AND_NAVIGATION_HEIGHT;
  }
  if (isTopBannerVisible) {
    return _presentationUtils.CSS_DESKTOP_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  return _presentationUtils.CSS_DESKTOP_HEIGHT;
};
exports.getDesktopCssHeightVariable = getDesktopCssHeightVariable;
const getSearchInputTopAttribute = ({
  isTopBannerVisible,
  showSearchOnScroll
}) => {
  if (isTopBannerVisible && showSearchOnScroll) {
    return `calc(${_presentationUtils.CSS_MOBILE_WITH_SEARCH_INPUT_WITH_TOP_AREA_BANNER_HEIGHT} - ${_presentationUtils.SEARCH_INPUT_HEIGHT}px)`;
  }
  if (showSearchOnScroll) {
    return `calc(${_presentationUtils.CSS_MOBILE_WITH_SEARCH_INPUT_HEIGHT} - ${_presentationUtils.SEARCH_INPUT_HEIGHT}px)`;
  }
  if (isTopBannerVisible) {
    return _presentationUtils.CSS_MOBILE_WITH_TOP_AREA_BANNER_HEIGHT;
  }
  return _presentationUtils.CSS_MOBILE_HEIGHT;
};
exports.getSearchInputTopAttribute = getSearchInputTopAttribute;
